import { ConnectComponent } from "util";
import View from "./data-table.view";
import Presenter from "./data-table.presenter";

export default ConnectComponent(View, Presenter);



// WEBPACK FOOTER //
// ./src/components/app/registration/user/data-table/index.js